module.exports = __webpack_public_path__ + "img/icon-coupon-applied.a5b856c3.svg";